import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.esm.js";
import { __require as t } from "../_node_modules/DGpmysib.esm.js";
var e = t();
const a = /* @__PURE__ */ r(e);
export {
  a as default
};
